export default "__VITE_ASSET__BP_mU96u__"